if (navigator.serviceWorker) {
  window.addEventListener('load', async () => {
    let registration = await navigator.serviceWorker.register('/serviceworker.js');

    console.log('[Companion]', 'Service worker registered!')
  })
} else {
  console.error('Service worker is not supported in this browser')
}
